import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Box, FormControlLabel, FormHelperText, Radio } from "@mui/material";
function RadioGroupOption(props) {
  const { value, disabled, label, description } = props.option;
  const labelValue = typeof label === "string" && label.length > 0 ? /* @__PURE__ */ jsx(Box, { paddingTop: "9px", children: label }) : label;
  return /* @__PURE__ */ jsx(
    FormControlLabel,
    {
      control: /* @__PURE__ */ jsx(Radio, {}),
      value,
      disabled,
      sx: { alignItems: "flex-start" },
      label: /* @__PURE__ */ jsxs(Fragment, { children: [
        labelValue,
        !!description && /* @__PURE__ */ jsx(FormHelperText, { children: description })
      ] })
    }
  );
}
export {
  RadioGroupOption
};
//# sourceMappingURL=RadioGroupOption.js.map
